export default __webpack_public_path__ + "static/media/by-raw-fin-fin.5a88eea4.png";